import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const controlClasses = cn(
    'w-full min-w-0 rounded-lg border border-input bg-card text-sm text-foreground shadow-card outline-none',
    'transition-[border-color,box-shadow,background-color] placeholder:text-muted-foreground/75',
    'hover:border-primary/30 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/20',
    'disabled:cursor-not-allowed disabled:opacity-55 dark:bg-input/25',
    'aria-invalid:border-destructive aria-invalid:ring-destructive/15'
)

export const Input: FC<ComponentProps<'input'>> = ({ className, type = 'text', ...props }): ReactNode => {
    return (
        <input
            type={type}
            className={cn(
                controlClasses,
                'h-10 px-3',
                'file:mr-3 file:h-full file:border-0 file:border-r file:border-input file:bg-transparent file:pr-3 file:text-[13px] file:font-semibold file:text-foreground',
                type === 'file' && 'cursor-pointer py-0 pl-0 text-muted-foreground file:cursor-pointer file:bg-muted file:px-3',
                className
            )}
            {...props}
        />
    )
}

export const Textarea: FC<ComponentProps<'textarea'>> = ({ className, ...props }): ReactNode => {
    return (
        <textarea
            className={cn(controlClasses, 'min-h-24 resize-y px-3 py-2.5 leading-relaxed', className)}
            {...props}
        />
    )
}
